module.exports = __webpack_public_path__ + "img/flavor12.a1648b05.svg";